// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manage-cookies[data-v-04407f2f]{color:#a363ff;cursor:pointer}", ""]);
// Exports
module.exports = exports;
